import { generatePath, Link } from "react-router-dom";

import { cn } from "@/libs/cn";
import { GridTableCell, Tag, Tooltip } from "@/modules/common/components";
import { LeadOriginLabels } from "@/modules/common/types/Leads.enum";
import { formatDate, formatPhoneNumber } from "@/modules/common/utils/format";
import { ROUTES } from "@/routes/constants/routes";
import { LeadListItemResponse } from "@/service/response/admin-leads";

import LeadStatusTag from "../LeadStatusTag";

import { gridLayout } from "./LeadListHeader";

interface LeadListLineProps {
  lead: LeadListItemResponse;
}

const LeadListLine = ({ lead }: LeadListLineProps) => {
  const detailsRoute = generatePath(ROUTES.LEADS.DETAILS, { id: lead.id });

  return (
    <Link
      to={detailsRoute}
      className={cn(
        gridLayout,
        "bg-white border border-[#D6DEE9] md:rounded-none md:border-0 md:border-t md:bg-transparent rounded-lg",
        "hover:bg-ui-hover transition-colors",
      )}
    >
      <GridTableCell label="Nome" className="md:min-w-0">
        <Tooltip label={lead.name}>
          <span className="block truncate text-sm font-medium text-ui-navy-dark">{lead.name}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Empresa" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={lead.company}>
          <span className="block truncate">{lead.company}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="E-mail" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={lead.email}>
          <span className="block truncate">{lead.email}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Telefone" className="text-sm text-ui-navy-dark">
        {lead.phoneNumber ? formatPhoneNumber(lead.phoneNumber) : "-"}
      </GridTableCell>

      <GridTableCell label="Segmento" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={lead.segment ?? undefined} disabled={!lead.segment}>
          <span className="block truncate">{lead.segment ?? "-"}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Origem">
        <Tag label={LeadOriginLabels[lead.originType] ?? lead.originType} variant="primary" />
      </GridTableCell>

      <GridTableCell label="Recebido em" className="text-sm text-ui-navy-dark">
        {formatDate(lead.createdAt, "DD/MM/YYYY HH:mm")}
      </GridTableCell>

      <GridTableCell label="Responsável" className="text-sm text-ui-navy-dark md:min-w-0">
        <Tooltip label={lead.responsibleBy?.name} disabled={!lead.responsibleBy?.name}>
          <span className="block truncate">{lead.responsibleBy?.name ?? "Não atribuído"}</span>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Status">
        <LeadStatusTag status={lead.status} />
      </GridTableCell>
    </Link>
  );
};

export default LeadListLine;
